module.exports = __webpack_public_path__ + "img/gongzuotai.11bcb919.png";